var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Defaults, ViewChild, CustomEventUtils, PropertyConverters, Utils, CustomUIEvent, avoidHandler, Logging } from '@pacem/pacem-core';
import { PacemBaseElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
const getUserMediaFunctions = Utils.getUserMediaFunctions();
export var SnapshotStep;
(function (SnapshotStep) {
    SnapshotStep["Start"] = "start";
    SnapshotStep["Taking"] = "taking";
    SnapshotStep["Confirm"] = "confirm";
})(SnapshotStep || (SnapshotStep = {}));
class ConfirmSnapshotEvent extends CustomUIEvent {
    constructor(buffer) {
        super('confirmsnapshot', { buffer });
    }
}
let PacemSnapshotElement = class PacemSnapshotElement extends PacemBaseElement {
    constructor() {
        super(...arguments);
        this._resizeHandler = (evt) => {
            this._renderValue();
        };
        this.step = SnapshotStep.Start;
        /*const*/ this._canUseWebcam = getUserMediaFunctions.length > 0;
        this._countdown = 0;
        this._webcamInitialized = false;
        this._grabberChangeHandler = (e) => {
            const input = this._grabber;
            if (input.files.length > 0) {
                Utils.blobToDataURL(input.files[0]).then(url => {
                    Utils.loadImage(url).then(img => {
                        this._shutter(img);
                    });
                });
            }
        };
        this._snapshooterClickHandler = (e) => {
            avoidHandler(e);
            this.step = SnapshotStep.Taking;
        };
        this._pickerClickHandler = (e) => {
            avoidHandler(e);
            this._grabber.click();
        };
        this._takerClickHandler = (e) => {
            avoidHandler(e);
            this._countdown = 0;
            this._shutter();
        };
        this._timerClickHandler = (e) => {
            avoidHandler(e);
            this._countdown = 3;
            this._shutter();
        };
        this._confirmerClickHandler = (e) => {
            avoidHandler(e);
            this.changeHandler(new ConfirmSnapshotEvent(this._buffer));
        };
    }
    get inputFields() {
        return [];
    }
    toggleReadonlyView(readonly) {
        // TODO
    }
    onChange(evt) {
        return new Promise((resolve, _) => {
            if (CustomEventUtils.isInstanceOf(evt, ConfirmSnapshotEvent)) {
                resolve(this.value = evt.detail.buffer);
                this.step = SnapshotStep.Start;
            }
            else {
                resolve(this.value);
            }
        });
    }
    acceptValue(val) {
        this._renderValue(val);
    }
    getViewValue(value) {
        return value;
    }
    convertValueAttributeToProperty(attr) {
        return PropertyConverters.String.convert(attr, this);
    }
    get _getUserMedia() {
        return this._canUseWebcam && getUserMediaFunctions[0];
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'step':
                switch (val) {
                    case SnapshotStep.Start:
                        this._buffer = null;
                        const input = this._grabber;
                        // https://stackoverflow.com/a/35323290
                        input.value = '';
                        if (!/safari/i.test(navigator.userAgent)) {
                            input.type = '';
                            input.type = 'file';
                        }
                        break;
                    case SnapshotStep.Taking:
                        this._ensureWebcamRunning();
                        break;
                }
                break;
            case '_buffer':
                this._renderValue(val || this.value);
                break;
            case 'width':
            case 'height':
                this._syncSize();
                break;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._syncSize();
        this._picker.addEventListener('click', this._pickerClickHandler, false);
        this._snapshooter.addEventListener('click', this._snapshooterClickHandler, false);
        this._taker.addEventListener('click', this._takerClickHandler, false);
        this._timer.addEventListener('click', this._timerClickHandler, false);
        this._confirmer.addEventListener('click', this._confirmerClickHandler, false);
        this._grabber.addEventListener('change', this._grabberChangeHandler, false);
    }
    disconnectedCallback() {
        if (this.isReady) {
            this._picker.removeEventListener('click', this._pickerClickHandler, false);
            this._snapshooter.removeEventListener('click', this._snapshooterClickHandler, false);
            this._taker.removeEventListener('click', this._takerClickHandler, false);
            this._timer.removeEventListener('click', this._timerClickHandler, false);
            this._confirmer.removeEventListener('click', this._confirmerClickHandler, false);
            this._grabber.removeEventListener('change', this._grabberChangeHandler, false);
        }
        super.disconnectedCallback();
    }
    _syncSize() {
        const canvas = this._stage, video = this._player;
        if (!Utils.isNull(canvas) && !Utils.isNull(video)) {
            canvas.style.width = video.style.width = (this.width && this.width + 'px') || '',
                canvas.style.height = video.style.height = (this.height && this.height + 'px') || '';
            this._renderValue(this._buffer || this.value);
        }
    }
    _shutter(el) {
        const me = this, video = this._player, canvas = this._stage;
        me._confirmer.disabled = true;
        if (Utils.isNull(el)) {
            el = me._player;
        }
        var srcWidth, srcHeight;
        if (el instanceof HTMLVideoElement) {
            srcWidth = el.videoWidth;
            srcHeight = el.videoHeight;
        }
        else {
            srcWidth = el.naturalWidth;
            srcHeight = el.naturalHeight;
        }
        if (me._countdown <= 0) {
            var cnv = document.createElement('canvas');
            cnv.width = this.width || canvas.clientWidth;
            cnv.height = this.height || canvas.clientHeight;
            var ctx = cnv.getContext('2d');
            Utils.cropImageOntoCanvas(el, ctx, srcWidth, srcHeight);
            let root = me._root;
            root.insertBefore(cnv, video);
            cnv.className = 'snapshot-brightout';
            setTimeout(function () {
                root.removeChild(cnv);
            }, 1000);
            me._refreshBuffer(cnv.toDataURL()).then((b) => {
                me._setToBeConfirmed(b);
                me._confirmer.disabled = false;
            });
        }
        else
            setTimeout(() => { me._countdown--; this._shutter(); }, 1000);
    }
    _renderValue(val = this.value) {
        let cnv = this._stage;
        if (!Utils.isNull(cnv)) {
            cnv.width = cnv.clientWidth;
            cnv.height = cnv.clientHeight;
            let ctx = cnv.getContext('2d');
            if (Utils.isNullOrEmpty(val)) {
                ctx.clearRect(0, 0, cnv.width, cnv.height);
            }
            else {
                Utils.loadImage(val).then(img => {
                    Utils.cropImageOntoCanvas(img, ctx, img.width, img.height);
                });
            }
        }
    }
    _setToBeConfirmed(buffer) {
        this.step = SnapshotStep.Confirm;
        this._buffer = buffer;
    }
    _refreshBuffer(buffer) {
        var cnv = this._stage;
        cnv.width = /*this.width ||*/ cnv.clientWidth;
        cnv.height = /*this.height ||*/ cnv.clientHeight;
        let quality;
        if (this.quality > 0) {
            quality = Math.min(1, Math.max(0, this.quality));
        }
        return Utils.cropImage(buffer, cnv.width, cnv.height, quality);
    }
    _ensureWebcamRunning() {
        if (this._canUseWebcam && !this._webcamInitialized) {
            var me = this;
            me._webcamInitialized = true;
            me._getUserMedia.apply(navigator, [{ video: true /*, audio: false*/ },
                /* success */ function (localMediaStream) {
                    var video = me._player;
                    // deprecated:
                    //video.src = window.URL.createObjectURL(localMediaStream);
                    // replaced with:
                    video.srcObject = localMediaStream;
                }, /* fail */ function (e) {
                    me.log(Logging.LogLevel.Error, (e || e.message).toString());
                }]);
        }
    }
};
__decorate([
    ViewChild('.' + PCSS + '-snapshot')
], PacemSnapshotElement.prototype, "_root", void 0);
__decorate([
    ViewChild('canvas')
], PacemSnapshotElement.prototype, "_stage", void 0);
__decorate([
    ViewChild('input[type=file]')
], PacemSnapshotElement.prototype, "_grabber", void 0);
__decorate([
    ViewChild('video')
], PacemSnapshotElement.prototype, "_player", void 0);
__decorate([
    ViewChild(P + '-button.button.snapshot-upload')
], PacemSnapshotElement.prototype, "_picker", void 0);
__decorate([
    ViewChild(P + '-button.button.snapshot-camera')
], PacemSnapshotElement.prototype, "_snapshooter", void 0);
__decorate([
    ViewChild(P + '-button.button.snapshot-take')
], PacemSnapshotElement.prototype, "_taker", void 0);
__decorate([
    ViewChild(P + '-button.button.snapshot-timer3s')
], PacemSnapshotElement.prototype, "_timer", void 0);
__decorate([
    ViewChild(P + '-button.button.snapshot-confirm')
], PacemSnapshotElement.prototype, "_confirmer", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemSnapshotElement.prototype, "step", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemSnapshotElement.prototype, "width", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemSnapshotElement.prototype, "height", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemSnapshotElement.prototype, "quality", void 0);
__decorate([
    Watch()
], PacemSnapshotElement.prototype, "_countdown", void 0);
__decorate([
    Watch({ emit: false })
], PacemSnapshotElement.prototype, "_buffer", void 0);
PacemSnapshotElement = __decorate([
    CustomElement({
        tagName: P + '-snapshot',
        shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-panel class="${PCSS}-snapshot" 
css-class="{{ { 
'snapshot-start': :host.step === '${SnapshotStep.Start}',
'snapshot-taking': :host.step === '${SnapshotStep.Taking}', 
'snapshot-confirm': :host.step === '${SnapshotStep.Confirm}' } }}">

    <${P}-resize target="{{ ::_stage }}" on-resize=":host._resizeHandler($event)"></${P}-resize>

    <canvas class="${PCSS}-viewfinder"></canvas>

    <video autoplay="autoplay"></video>

    <input type="file" accept="image/*" />

    <div class="${PCSS}-buttonset snapshot-step step-start">
        <div class="buttonset-center">
            <${P}-button class="button snapshot-upload" icon-glyph="upload"></${P}-button>
            <${P}-button class="button snapshot-camera" icon-glyph="photo_camera"></${P}-button>            
        </div>
    </div>

    <div class="${PCSS}-buttonset snapshot-step step-taking">
        <div class="buttonset-center">
            <${P}-button class="button snapshot-undo" icon-glyph="undo" on-click=":host.step = '${SnapshotStep.Start}'"></${P}-button>
            <${P}-button class="button snapshot-take" icon-glyph="camera"></${P}-button>
            <${P}-button class="button snapshot-timer3s" icon-glyph="timer_3"></${P}-button>
        </div>
    </div>

    <div class="${PCSS}-buttonset snapshot-step step-confirm">
        <div class="buttonset-center">
            <${P}-button class="button snapshot-undo" icon-glyph="undo" on-click=":host.step = '${SnapshotStep.Start}'"></${P}-button>
            <${P}-button class="button snapshot-confirm" icon-glyph="done"></${P}-button>
        </div>
    </div>

    <${P}-span class="snapshot-countdown" text="{{ :host._countdown }}" hide="{{ :host.step !== '${SnapshotStep.Taking}' || !(:host._countdown > 0) }}"></${P}-span>
    <${P}-span hide="{{ :host._canUseWebcam }}"><${P}-content></${P}-content></${P}-span>

</${P}-panel>`
    })
], PacemSnapshotElement);
export { PacemSnapshotElement };
